<template>
  <div class="page-wrapper ticket-wrapper ticket-manage-wrapper">
    <div class="container-fluid">
      <div class="breadcrumbwrapper d-flex justify-content-between align-items-center gap-3 flex-wrap pb-2">
        <breadcrumb :items="breadcrumbItems" />
        <button class="btn univ-btn btn-secondary mt-0 d-inline-flex align-items-center justify-content-center gap-2"
          @click="openModal(row, 'AddTicketModal')">
          <span><i class="fas fa-add"></i></span>
          Add Ticket </button>
      </div>
      <div class="row mt-4">
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card total-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd"
                  d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
                Total Issues
              </div>
              <div class="issueCount clr-title fw-bold">
                {{ stats.total_issues }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card active-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                  <path fill="currentColor"
                    d="M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7.17a3.001 3.001 0 0 1 5.66 0H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17a3.001 3.001 0 0 1-5.66 0zM2 7a3 3 0 0 1 3-3h8a1 1 0 0 1 1 1a1 1 0 1 0 2 0a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2a1 1 0 0 1-1-1a1 1 0 1 0-2 0a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3zm13 2a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1m1 4.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0z" />
                </g>
              </svg>
            </div>
            <div class="contentwrapper  ">
              <div class="content-title">
               Assigned Active Issues
              </div>
              <div class="issueCount clr-title fw-bold">
                {{ stats.open_issues }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card closed-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                  <path stroke-linejoin="round"
                    d="M9 16L34 6l4 10M4 16h40v6c-3 0-6 2-6 5.5s3 6.5 6 6.5v6H4v-6c3 0 6-2 6-6s-3-6-6-6z" />
                  <path d="M17 25.385h6m-6 6h14" />
                </g>
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
               Assigned Closed Issues
              </div>
              <div class="issueCount clr-title fw-bold">
                {{ stats.closed_issues }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 mb-3">
          <div class="ticket_card open-issue-card d-flex align-items-center gap-3 h-100">
            <div class="iconwrapper d-flex align-items-center justify-content-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 640 512">
                <path fill="currentColor"
                  d="M144 160a80 80 0 1 0 0-160a80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160a80 80 0 1 0 0 160M0 298.7C0 310.4 9.6 320 21.3 320h214c-26.6-23.5-43.3-57.8-43.3-96c0-7.6.7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7M320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96m65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.4C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.6c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2l-.1-.2l-2.4-4.1l-.1-.2l-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8.5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9V492c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0a40 40 0 1 1-80 0" />
              </svg>
            </div>
            <div class="contentwrapper">
              <div class="content-title">
                Created by Me
              </div>
              <div class="issueCount clr-title fw-bold">
                {{ stats.created_by_me }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ticket-card p-3 mt-3 ticket-list-wrapper">
          <b-card no-body>
              <b-tabs card v-model="tabIndex">
                <b-tab 
                  title="Assigned Tickets" 
                  active 
                  @click="tabIndex = 0;"
                >
                  <b-card-text>
                    <div class="filterwrapper d-flex align-items-center flex-wrap gap-3 mb-3">

                      <div class="search_input_wrapper position-relative">
                        <input type="text" v-model.lazy="assignedSearchQuery" class="form-control border-0 font-14 " placeholder="Enter Submitter Name" />
                        <div class="iconwrapper position-absolute clr-bold-grey">
                          <i class="fa-solid fa-magnifying-glass cursor-pointer" @click="getAssignedTickets"></i>
                        </div>
                      </div>
                      
                      <b-dropdown variant="light" class=" filterdropdownwrapper" menu-class="w-100">
                            <template #button-content>
                              <span class="dropdownlabel clr-bold-grey fw-normal font-14 "><span class="me-1">Status:</span> {{
                                assignedSelectedStatus || 'Select' }}</span>
                          </template>
                          <b-dropdown-item v-for="(status, index) in statusOptions" :key="'status-' + index + '-' + status" 
                          @click="assignedSelectedStatus = status"
                          :active="assignedSelectedStatus === status" class="font-14">
                          {{ status }}
                        </b-dropdown-item>
                      </b-dropdown>
                  
                      <b-dropdown variant="light" class=" filterdropdownwrapper" menu-class="w-150 scrollable-menu">
                        <template #button-content>
                          <span class="dropdownlabel clr-bold-grey fw-normal font-14 "><span>Category:</span> {{ assignedSelectedCategory ||
                              'Select' }}</span>
                          </template>
                          <b-dropdown-item v-for="(category, index) in categoryOptions" :key="'category-' + index + '-' + category" 
                          @click="assignedSelectedCategory = category"
                          :active="assignedSelectedCategory === category" class="font-14">
                          {{ category }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  
                    <div class="py-1 pagination-container flex-wrap gap-2">
                      <div class="pagination-info">
                        Showing {{ ticketData.from }} to {{ ticketData.to }} of {{ ticketData.total }} results
                      </div>
                      <div class="pagination-controls">
                        <button :disabled="!ticketData.prev_page_url" @click="changeAssignedPage('first')" class="btn btn-link">First</button>
                        <button :disabled="!ticketData.prev_page_url" @click="changeAssignedPage('prev')" class="btn btn-link">Prev</button>
                        <span
                          v-for="page in pageNumbers"
                          :key="page"
                          class="btn btn-link"
                          :class="{ 'active': page === assignedCurrentPage }"
                          @click="changeAssignedPage(page)"
                        >{{ page }}</span>
                        <button :disabled="!ticketData.next_page_url" @click="changeAssignedPage('next')" class="btn btn-link">Next</button>
                        <button :disabled="!ticketData.next_page_url" @click="changeAssignedPage('last')" class="btn btn-link">Last</button>
                      </div>
                    </div>

                    <div class="table-responsive clientsData-wrap mt-4">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>
                              Issue Details
                            </th>
                            <!-- <th>
                              Priority
                            </th> -->
                            <th>
                              Submitter Details
                            </th>
                            <th>
                              Comments
                            </th>
                            <th>
                              Status
                            </th>
                            <th>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="tickets && tickets.length > 0">
                          <tr v-for="(ticket, index) in tickets.filter(t => t !== null)" :key="`assigned-ticket-${ticket?.id || 'idx-'+index}`">
                            <td>
                              <div
                                class="issue-category font-13 clr-black fw-semibold d-inline-flex align-items-center justify-content-center mb-2 badgecontainer">
                                {{ getCategoryName(ticket) }}
                              </div>
                              <div class="issue-title clr-title" v-if="ticket">
                                <strong>Title:</strong> {{ ticket.title || 'No title available' }}
                              </div>
                            </td>
                            <td v-if="ticket">
                              <div class="submitter-name clr-title fw-semibold lh-base">
                                {{ getSubmitterName(ticket.submitter) }}
                              </div>
                              <div class="submitter-email clr-bold-grey lh-base">
                                {{ getSubmitterEmail(ticket.submitter) }}
                              </div>
                            </td>
                            <td v-if="ticket">
                              <div class="comment-count fw-medium">{{ getCommentCount(ticket) }}</div>
                            </td>
                            <td v-if="ticket">
                              <div :class="['d-inline-flex align-items-center justify-content-center badgecontainer', getStatusClass(ticket.status)]">
                               <span
                                  :class="['badge-dot', ticket.status === 1 ? 'open' : 'closed']"
                                ></span>
                                <span>{{ getStatusText(ticket.status) }}</span>
                              </div>
                            </td>
                            <td v-if="ticket">
                              <div class="action-icons">
                                <custom-route-button 
                                  title="View Details" 
                                  iconClass="fas fa-eye" 
                                  :routeLink="{
                                    name: 'TicketDetail',
                                    params: { ticketId: ticket.id }
                                  }" 
                                />
                                <!-- <custom-button
                                v-if="ticket.status == 1"
                                @onClicked="handleTicketAction(ticket)"
                                title="Close"
                                iconClass="fas fa-close"
                                /> -->
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              {{ loading ? 'Loading tickets...' : 'No tickets found' }}
                            </td>
                          </tr>


                        </tbody>
                      </table>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab
                  title="Created by Me"
                  @click="tabIndex = 1;" 
                >
                  <div class="filterwrapper d-flex align-items-center flex-wrap gap-3 mb-3">
                    <!--<div class="search_input_wrapper position-relative">
                      <input type="text" v-model.lazy="createdSearchQuery" class="form-control border-0 font-14 " placeholder="Enter Submitter Name" />
                      <div class="iconwrapper position-absolute clr-bold-grey">
                        <i class="fa-solid fa-magnifying-glass cursor-pointer" @click="getCreatedTickets"></i>
                      </div>
                    </div>-->
                    
                    <b-dropdown variant="light" class=" filterdropdownwrapper" menu-class="w-100">
                          <template #button-content>
                            <span class="dropdownlabel clr-bold-grey fw-normal font-14 "><span class="me-1">Status:</span> {{
                              createdSelectedStatus || 'Select' }}</span>
                        </template>
                        <b-dropdown-item 
                          v-for="(status, index) in statusOptions" 
                          :key="'created-status-' + index + '-' + status" 
                          @click="createdSelectedStatus = status"
                          :active="createdSelectedStatus === status" 
                          class="font-14">
                          {{ status }}
                        </b-dropdown-item>
                    </b-dropdown>
                
                    <b-dropdown variant="light" class=" filterdropdownwrapper" menu-class="w-100 scrollable-menu">
                      <template #button-content>
                        <span class="dropdownlabel clr-bold-grey fw-normal font-14 "><span>Category:</span> {{ createdSelectedCategory ||
                            'Select' }}</span>
                        </template>
                        <b-dropdown-item 
                          v-for="(category, index) in categoryOptions" 
                          :key="'created-category-' + index + '-' + category" 
                          @click="createdSelectedCategory = category"
                          :active="createdSelectedCategory === category" 
                          class="font-14">
                          {{ category }}
                        </b-dropdown-item>
                    </b-dropdown>
                  </div>

                  <div class="py-1 pagination-container flex-wrap gap-2">
                      <div class="pagination-info">
                        Showing {{ createdticketData.from }} to {{ createdticketData.to }} of {{ createdticketData.total }} results
                      </div>
                      <div class="pagination-controls">
                        <button :disabled="!createdticketData.prev_page_url" @click="changeCreatedPage('first')" class="btn btn-link">First</button>
                        <button :disabled="!createdticketData.prev_page_url" @click="changeCreatedPage('prev')" class="btn btn-link">Prev</button>
                        <span
                          v-for="page in createdPageNumbers"
                          :key="page"
                          class="btn btn-link"
                          :class="{ 'active': page === createdCurrentPage }"
                          @click="changeCreatedPage(page)"
                        >{{ page }}</span>
                        <button :disabled="!createdticketData.next_page_url" @click="changeCreatedPage('next')" class="btn btn-link">Next</button>
                        <button :disabled="!createdticketData.next_page_url" @click="changeCreatedPage('last')" class="btn btn-link">Last</button>
                      </div>
                  </div>

                  <div class="table-responsive clientsData-wrap mt-4">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Issue Details  
                          </th>
                          <!-- <th>
                            Priority
                          </th> -->
                          <th>
                            Submitter Details
                          </th>
                          <th>
                            Comments
                          </th>
                          <th>
                            Status
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody v-if="createdtickets && createdtickets.length > 0">
                        <tr v-for="(ticket, index) in createdtickets" :key="`created-ticket-${ticket?.id || 'idx-'+index}`">
                          <td>
                            <div
                              class="issue-category font-13 clr-black fw-semibold d-inline-flex align-items-center justify-content-center mb-2 badgecontainer">
                              {{ getCategoryName(ticket)?getCategoryName(ticket):'Unknown' }}
                            </div>
                            <div class="issue-title clr-title "> <strong>Title:</strong> {{ ticket.title || 'No title available' }}</div>
                          </td>
                          <td>
                            <div
                            class="submitter-name clr-title fw-semibold lh-base">
                              {{ getSubmitterName(ticket.submitter)?? 'Unknown' }}
                            </div>
                            <div class="submitter-email clr-bold-grey lh-base">
                              {{ getSubmitterEmail(ticket.submitter)?? 'Unknown' }}
                            </div>
                          </td>
                          <td>
                            <div class="comment-count fw-medium">{{ getCommentCount(ticket)?? '0' }}</div>
                          </td>
                          <td>  
                            <div :class="['d-inline-flex align-items-center justify-content-center badgecontainer',getStatusClass(ticket.status)]">
                               <span
                                  :class="['badge-dot', ticket.status === 1 ? 'open' : 'closed']"
                                ></span>
                                <span>{{ getStatusText(ticket.status)?? 'Unknown' }}</span>
                            </div>
                            </td>
                          <td>
                            <div class="action-icons">
                              <custom-route-button  v-if="ticket" title="View Details" iconClass="fas fa-eye" :routeLink="{
                                name: 'TicketDetail',
                                params: { ticketId: ticket.id }
                              }" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="5" class="text-center">
                            {{ createdLoading ? 'Loading tickets...' : 'No tickets found' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
      </div>
    </div>
    <AddTicketModal id="AddTicketModal" :member.sync="row" @onCloseModal="row = null" :categories="categories" @onSuccess="reloadPage" />
  </div>

</template>

<script>
import axios from "axios";
import Helper from "@/resource/Helper";
import AddTicketModal from "./modal/AddTicketModal.vue";

const headers = {
        'X-Authorization': Helper.messageCenterToken(),
        'X-Ticketing-Token': Helper.ticketingToken(),
        'Content-Type': 'application/json'
};
      
export default {
  components: {
    AddTicketModal,
  },
  name: "ManageTicket",
  data: () => ({
    row: {},
    tabIndex: 0,
    breadcrumbItems: [{ title: "Manage Tickets", active: true }],
    component: "",
    showForm: true,
    rows: [],
    ticketData: {},
    createdticketData:{},
    tickets: [],
    createdtickets:[],
    statusOptions: ['All', 'Open', 'Close'],
    priorityOptions: ['All', 'High', 'Low', 'Medium'],
    categoryOptions: ['All'], // Will be populated dynamically
    // Assigned tickets filters & pagination
    assignedSelectedStatus: 'All',
    assignedSelectedPriority: 'All',
    assignedSelectedCategory: 'All',
    assignedSearchQuery: '',
    assignedCurrentPage: 1,
    assignedPerPage: 10,
    loading: false,
    categories: [], // Store all categories from API
    // Created-by-me filters & pagination
    createdSelectedStatus: 'All',
    createdSelectedPriority: 'All',
    createdSelectedCategory: 'All',
    createdSearchQuery: '',
    createdCurrentPage: 1,
    createdPerPage: 10,
    stats: {
      total_issues: 0,
      open_issues: 0,
      closed_issues: 0,
      created_by_me: 0,
    },
    createdLoading: false,
  }),
  computed: {
    filterQuery() {
      return {
        agent_id: this.$store.getters.repId,
      };
    },
    pageNumbers() {
      const totalPages = this.ticketData.last_page || 1;
      const pages = [];
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    createdPageNumbers() {
      const totalPages = this.createdticketData.last_page || 1;
      const pages = [];
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    repEmail(){
       return this.$store.getters.rep.email
    }
  },
  methods: {
    openModal(row, modalId) {
      this.row = row;
      this.$bvModal.show(modalId);
    },

    getCategories() {
      const url = `${process.env.VUE_APP_TICKETING_URL}v1/tickets/category`;
      axios
        .get(url, { headers })
        .then((res) => {
          this.categories = res.data.data;
          this.categories.forEach((category) => {
            this.categoryOptions.push(category.name);
          });
        })
        .catch(() => {
          this.categories = ['All'];
        });
    },
    
    async getAssignedTickets() {
      this.loading = true;
      let loader = this.$loading.show();
      const agentId = this.$store.getters.repId;
      const url = `${process.env.VUE_APP_TICKETING_URL}v2/agent/assigned-tickets`;
     
      const params = {
        agent_id: agentId,
        per_page: this.assignedPerPage,
        page: this.assignedCurrentPage
      };

      if (this.assignedSelectedStatus !== 'All') {
        params.status = this.assignedSelectedStatus === 'Open' ? 1 : 2;
      }

      if (this.assignedSelectedCategory !== 'All') {
        params.category_name = this.assignedSelectedCategory;
      }

      if (this.assignedSearchQuery && this.assignedSearchQuery.trim()) {
        params.submitter_name = this.assignedSearchQuery.trim();
      }

      try {
        const response = await axios.get(url, { headers, params });
        if (response.data && response.data.success && response.data.data) {
          this.ticketData = response.data.data;
          this.tickets = response.data.data.data || [];
        } else {
          this.tickets = [];
          this.ticketData = {};
        }
      } catch (error) {
        console.error('Error fetching assigned tickets:', error);
        this.tickets = [];
        this.ticketData = {};
      } finally {
        this.loading = false;
        loader.hide();
      }
    },
    async getCreatedTickets() {
      this.createdLoading = true;
      let loader = this.$loading.show();
      const url = `${process.env.VUE_APP_TICKETING_URL}v2/agent/my-tickets`;
     
      const params = {
        email: this.repEmail,
        per_page: this.createdPerPage,
        page: this.createdCurrentPage
      };

      if (this.createdSelectedStatus !== 'All') {
        params.status = this.createdSelectedStatus === 'Open' ? 1 : 2;
      }

      if (this.createdSelectedCategory !== 'All') {
        params.category_name = this.createdSelectedCategory;
      }

      if (this.createdSearchQuery && this.createdSearchQuery.trim()) {
        params.submitter_name = this.createdSearchQuery.trim();
      }

      try {
        const response = await axios.get(url, { headers, params });
        if (response.data && response.data.success && response.data.data) {
          this.$set(this, 'createdticketData', response.data.data);
          this.$set(this, 'createdtickets', response.data.data.data || []);
        } else {
          this.createdtickets = [];
          this.createdticketData = {};
        }
      } catch (error) {
        console.error('Error fetching assigned tickets:', error);
        this.createdtickets = [];
        this.createdticketData = {};
      } finally {
        this.createdLoading = false;
        loader.hide();
      }
    },
    getCategoryName(ticket) {
      return ticket && ticket.category && ticket.category.name ? ticket.category.name : 'Unknown';
    },
    getCommentCount(ticket) {
      return ticket.issue_comment_count || 0;
    },
    getSubmitterName(submitter) {
      if (!submitter) return 'N/A';
      return `${submitter.first_name || ''} ${submitter.last_name || ''}`.trim() || 'N/A';
    },
    getSubmitterEmail(submitter) {
      return submitter?.email || 'N/A';
    },
    getStatusText(status) {
      return status === 1 ? 'Open' : 'Close';
    },
    getStatusClass(status) {
      return status === 1 ? 'issue-status' : 'closeissue-status';
    },
    getTicketDetail(row) {
      this.hideForm();
      this.row = row;
      let loader = this.$loading.show();
      let url = `${process.env.VUE_APP_TICKETING_URL}v1/issue/detail/${row.id}`;
      axios
        .get(url, { headers })
        .then((res) => {
          this.row = res.data.data;
        })
        .catch(() => {
          this.row = {};
        })
        .finally(() => {
          loader.hide();
        });
    },

    async getStatsByAgent(){
      let loader = this.$loading.show();
      let url = `${process.env.VUE_APP_TICKETING_URL}v2/agent/stats`;

      const params = {
        agent_id: this.$store.getters.repId,
        email: this.$store.getters.repEmail,
      };

       await axios.get(url, { headers,params})
       .then((res) => {
         const {total_issues, open_issues, closed_issues, created_by_me} = res.data.data;
         this.stats={
           total_issues,
           open_issues,
           closed_issues,
           created_by_me,
         };
       })
       .catch(() => {
         this.stats = {};
       })
       .finally(() => {
         loader.hide();
       });
    },


    getTickets() {
      let loader = this.$loading.show();
      let url = `${process.env.VUE_APP_TICKETING_URL}v1/issue/list`;
      if (Object.keys(this.filters).length) {
        let filterUrl = Helper.objToUrlParams(this.filters);
        if (this.rows && Object.keys(this.rows).length) {
          const currentPage = this.rows.current_page;
          filterUrl = `${filterUrl}&page=${currentPage}`;
        }
        url = `${url}?${filterUrl}`;
      }
      axios
        .get(url, { headers })
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = null;
        })
        .finally(() => {
          loader.hide();
        });
    },
    handleTicketAction(row) {
      let action = {
        title: row.status ? "Close" : "Re-open",
        url: `${process.env.VUE_APP_TICKETING_URL}v2/agent/issues`,
      };
      this.$confirm({
        title: `${action.title} Ticket`,
        message: `Do you want to ${action.title.toLowerCase()} ticket ?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            let headers = {
              'X-Authorization': Helper.messageCenterToken(),
              'X-Ticketing-Token': Helper.ticketingToken(),
            };
            let loader = this.$loading.show();
            let url = `${action.url}/${row.id}/${row.status ? "close" : "reopen"}`;
            axios
              .put(url, { agent_id: this.$store.getters.repId }, { headers })
              .then((res) => {
                this.$notify(res.data.message);
                this.getAssignedTickets();
                this.getTicketDetail(row);
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "error");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    },
    openForm() {
      this.showForm = true;
    },
    hideForm() {
      this.showForm = false;
    },   
    handleSuccess(row) {
      this.getTicketDetail(row);
      // update comment count
      this.getAssignedTickets();
    },
    changeAssignedPage(page) {
      if (page === 'first') this.assignedCurrentPage = 1;
      else if (page === 'prev' && this.ticketData.prev_page_url) this.assignedCurrentPage--;
      else if (page === 'next' && this.ticketData.next_page_url) this.assignedCurrentPage++;
      else if (page === 'last') this.assignedCurrentPage = this.ticketData.last_page;
      else this.assignedCurrentPage = page;
      this.getAssignedTickets();
    },
    changeCreatedPage(page) {
      if (page === 'first') this.createdCurrentPage = 1;
      else if (page === 'prev' && this.createdticketData.prev_page_url) this.createdCurrentPage--;
      else if (page === 'next' && this.createdticketData.next_page_url) this.createdCurrentPage++;
      else if (page === 'last') this.createdCurrentPage = this.createdticketData.last_page;
      else this.createdCurrentPage = page;
      this.getCreatedTickets();
    },
    async reloadPage(){
      console.log("Refreshing ticket data...");
      await this.getAssignedTickets();
      await this.getCreatedTickets();
      await this.getStatsByAgent();
    }
  },
  created() {
    this.getAssignedTickets();
    this.getStatsByAgent();
    this.getCategories();
    this.getCreatedTickets()
  },
  watch: {
    assignedSelectedStatus() {
      this.assignedCurrentPage = 1;
      this.getAssignedTickets();
    },
    assignedSelectedCategory() {
      this.assignedCurrentPage = 1;
      this.getAssignedTickets();
    },
    assignedSearchQuery() {
      this.assignedCurrentPage = 1;
      this.getAssignedTickets();
    },
    createdSelectedStatus() {
      this.createdCurrentPage = 1;
      this.getCreatedTickets();
    },
    createdSelectedCategory() {
      this.createdCurrentPage = 1;
      this.getCreatedTickets();
    },
    createdSearchQuery() {
      this.createdCurrentPage = 1;
      this.getCreatedTickets();
    }
  }
};
</script>

<style src="@/assets/css/ticketing.css"></style>
<style scoped>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.pagination-info {
  margin: 0;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-link {
  padding: 0 5px;
  color: #007bff;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
}

.btn-link:hover {
  text-decoration: underline;
}

.btn-link.active {
  color: #0056b3;
  font-weight: bold;
}

.btn-link:disabled {
  color: #6c757d;
  cursor: not-allowed;
}

::v-deep .scrollable-menu {
  max-height: 200px;
  overflow-y: auto;
}
</style>